<template>
  <v-alert
    id="apiError"
    v-model="apiError.show"
    type="error"
    color="danger"
    border="left"
    dense
    outlined
    dismissible
  >
    <template v-slot:close>
      <v-icon color="danger" v-text="mdiWindowClose" @click="closeNotice('apiError')"/>
    </template>
    {{ apiError.message }}
  </v-alert>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { mdiWindowClose } from '@mdi/js';

export default {
  name: 'apiErrorAlert',
  data() {
    return {
      mdiWindowClose
    };
  },
  watch: {
    apiError() {
      if (this.apiError) this.$vuetify.goTo('#apiError');
    }
  },
  computed: {
    ...mapGetters([
      'apiError'
    ])
  },
  methods: {
    ...mapMutations([
      'closeNotice'
    ])
  }
};
</script>
